import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  fileDisplay: {
    minWidth: '6.25rem',
    maxWidth: '12.5rem',
    mx: 1,
    my: 0.5,
    flexGrow: 1,
    flexBasis: 0,
  },

  cardWrapper: {
    width: '100%',
    paddingTop: '62.5%',
    position: 'relative',
  },

  card: (downloadable: boolean) => (theme: Theme) => ({
    border: `1px solid ${theme.colors.neutral[200]}`,
    display: 'block',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    textDecoration: 'none',
    overflow: 'hidden',
    boxSizing: 'border-box',
    position: 'absolute',

    ':hover': downloadable
      ? {
          boxShadow: `0 4px 18px ${alpha(theme.colors.primary[500], 0.2)}`,
          button: {
            opacity: 1,
          },
        }
      : {},
  }),

  cardDelete: {
    width: '1rem',
    minWidth: '1rem',
    height: '1rem',
    minHeight: '1rem',
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    border: 'none',
    padding: 0,
  },

  loadingIndicator: {
    justifyContent: 'center',
    alignItems: 'center',
  },

  cardImage: (imageUrl: string) => ({
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
    height: '100%',
    backgroundImage: `url(${imageUrl})`,
  }),

  cardExtension: (theme: Theme) => ({
    color: theme.colors.neutral[400],
    fontSize: 40,
    lineHeight: '3rem',
    fontWeight: 'bold',
  }),

  filename: {
    cursor: 'default',
    marginTop: 0.5,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
};
